import { Injectable } from '@angular/core';
import { ReferenceDao } from '@app/dao/reference/reference.dao';

import { HttpApiService } from '@app/providers/http-api/http-api.service';
import { environment } from '@environments/environment';

import { Observable, of, map } from 'rxjs';
// import 'rxjs/add/observable/of';

@Injectable({
  providedIn: 'root',
})
export class RefDataService {
  personalUseType: any;
  maritalStatus: any;
  departments: any;
  marriageRegimes: any;
  legalCapacity: any;
  subscriptionSources: any;
  tangibleCategories: any;
  relationsTypes: any;
  managersProduct: any;
  activitySectors: any;
  investorCategories: any;
  investisorType: any;
  legalForms: any;
  taxResidences: any;
  taxeSystems: any;
  loanTypeProjet: any;
  loanTypeRate: any;

  worldContinents: any;
  frAllAll: any;

  baseUrlAssets = '';

  periodicityType: any;
  estateTypeList: any;
  fiscallaws: any;
  fiscaltypes: any;

  constructor(
    private httpApi: HttpApiService,
    private referenceDao: ReferenceDao,
  ) {}

  getFiscallaws(): any {
    if (this.fiscallaws) {
      return of(this.fiscallaws);
    }

    return this.httpApi.get(`/ref/fiscallaw`).pipe(
      map(val => {
        this.fiscallaws = val;
        return val;
      }),
    );
  }

  getFiscalTypes(): any {
    if (this.fiscallaws) {
      return of(this.fiscallaws);
    }

    return this.httpApi.get(`/ref/fiscalType`).pipe(
      map(val => {
        this.fiscaltypes = val;
        return val;
      }),
    );
  }

  getCountries(): any {
    return this.referenceDao.getCountries();
  }

  getRelationsTypes(): any {
    if (this.relationsTypes) {
      return of({ data: this.relationsTypes });
    }
    return this.httpApi.get(`/ref/relationType`);
  }

  getPersonalUseType(): any {
    if (this.personalUseType) {
      return of({ data: this.personalUseType });
    }
    return this.httpApi.get(`/ref/personalUseType`);
  }

  getEstateType(): any {
    if (this.estateTypeList) {
      return of({ data: this.estateTypeList });
    }
    return this.httpApi.get(`/ref/immoExpenseType`);
  }

  getPeriodicityType(): any {
    if (this.periodicityType) {
      return of({ data: this.periodicityType });
    }
    return this.httpApi.get(`/ref/periodicityType`);
  }

  getMaritalStatus(): any {
    if (this.maritalStatus) {
      return of({ data: this.maritalStatus });
    }
    return this.httpApi.get(`/ref/maritalStatus`);
  }

  getDepartments(country: string = 'fr'): any {
    if (this.departments) {
      return of({ data: this.departments });
    }
    return this.httpApi.get(`/ref/department/${country}`);
  }

  getMarriageRegimes(): any {
    if (this.marriageRegimes) {
      return of({ data: this.marriageRegimes });
    }
    return this.httpApi.get(`/ref/marriageRegime`);
  }

  getLoanTypeProjet(): any {
    if (this.loanTypeProjet) {
      return of({ data: this.loanTypeProjet });
    }
    return this.httpApi.get(`/ref/loanProjetType`);
  }

  getLoanTypeRate(): any {
    if (this.loanTypeRate) {
      return of({ data: this.loanTypeRate });
    }
    return this.httpApi.get(`/ref/loanRateType`);
  }

  /* high charts data */
  getWorldContinents(): any {
    if (this.worldContinents) {
      return of(this.worldContinents);
    }
    return this.httpApi.get(
      environment.servers.client.root + `/assets/geo/world-continents.geo.json`,
    );
  }

  getFrAllAll(): any {
    if (this.frAllAll) {
      return of(this.frAllAll);
    }
    return this.httpApi.get(
      environment.servers.client.root + `/assets/geo/fr-all-all.geo.json`,
    );
  }

  getLegalCapacity(): any {
    if (this.legalCapacity) {
      return of({ data: this.legalCapacity });
    }
    return this.httpApi.get(`/ref/legalCapacity`);
  }

  getSubscriptionSource(): Observable<any> {
    if (this.subscriptionSources) {
      return of({ data: this.subscriptionSources });
    }
    return this.httpApi.get(`/ref/subscriptionSource`);
  }

  getCompanyActivitySectorRefs(): any {
    if (this.subscriptionSources) {
      return of({ data: this.subscriptionSources });
    }
    return this.httpApi.get(`/ref/companies/activity-sectors`);
  }

  getCompanyInvestorCategoryRefs(): any {
    if (this.subscriptionSources) {
      return of({ data: this.subscriptionSources });
    }
    return this.httpApi.get(`/ref/companies/investor-categories`);
  }

  getCompanyInvestorTypeRefs(): any {
    if (this.subscriptionSources) {
      return of({ data: this.subscriptionSources });
    }
    return this.httpApi.get(`/ref/companies/investor-types`);
  }

  getCompanyLegalFormRefs(): any {
    if (this.subscriptionSources) {
      return of({ data: this.subscriptionSources });
    }
    return this.httpApi.get(`/ref/companies/legal-forms`);
  }

  getCompanyTaxResidenceRefs(): any {
    if (this.subscriptionSources) {
      return of({ data: this.subscriptionSources });
    }
    return this.httpApi.get(`/ref/companies/tax-residences`);
  }

  getCompanyTaxSystemRefs(): any {
    if (this.subscriptionSources) {
      return of({ data: this.subscriptionSources });
    }
    return this.httpApi.get(`/ref/companies/tax-systems`);
  }

  getTangibleCategories(): any {
    if (this.tangibleCategories) {
      return of({ data: this.tangibleCategories });
    }
    return this.httpApi.get(`/ref/tangibleCategory`);
  }

  getManagersProduct(product): any {
    if (this.managersProduct) {
      return of({ data: this.managersProduct });
    }
    return this.httpApi.get(`/ref/manager/product/${product}`);
  }

  getApplicationTheme(): { colors: string[] } {
    return {
      colors: ['#FFC453', '#C97800', '#CE9F47', '#F9A11D', '#ECAB13'],
    };
  }
}
